import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import JobCategory from "../../../CommonPage/Home/JobCategory/JobCategory";
import "./JobTab.css";
import FirstTab1 from "./FirstTab1/FirstTab1";
import SecondJobTab from "../SecondJobTab/SecondJobTab";
import ThirdJobTab from "../ThirdJobTab/ThirdJobTab";
import JobAlert from "../JobAlert/JobAlert";
import SixthJobTab from "../SixthJobTab/SixthJobTab";
import FifthJobTab from "../FifithJobTab/FifthJobTab";
import ExploreOpportunity from "../ExploreOpportunity/ExploreOpportunity";
import MyPortfolio from "../../my-portfolio/MyPortfolio";
import "swiper/swiper-bundle.css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import ScrollableTab from "../../ScrollableTab/ScrollableTab";

// Each stage of the job-seeker journey gets a short caption so the
// numbered rail marker isn't just a bare number — it tells you what
// that stage is for at a glance.
const stages = [
  { title: "My Portfolio", caption: "Build your profile" },
  { title: "Dashboard", caption: "See what's new" },
  { title: "Shortlisted", caption: "Recruiters' picks" },
  { title: "About Interview", caption: "Get interview-ready" },
  { title: "Saved Jobs", caption: "Your watchlist" },
  { title: "Applied", caption: "Track your applications" },
];

const StageTab = ({ title, caption }) => (
  <>
  <div>

    <span className="stage-title">{title} </span>
    <span className="stage-caption">{caption}</span>
  </div>
  </>
);

const JobTabs = () => {
  return (
    <>
      <section className="main-tabs">
        <div className="container-fluid p-0">
          <div className="main-design-tab msindddd">
            <div className="main-design-desktop-tab">
              <Tabs>
                <div className="container">
                  <TabList className="job-tabs-list">
                    {stages.map((stage) => (
                      <Tab key={stage.title}>
                        <StageTab title={stage.title} caption={stage.caption} />
                      </Tab>
                    ))}
                  </TabList>
                </div>

                <TabPanel>
                  <MyPortfolio />
                </TabPanel>

                <TabPanel>
                  <FirstTab1 />
                  <JobCategory alignment="left" />
                  <JobAlert />
                  <ExploreOpportunity />
                </TabPanel>

                <TabPanel>
                  <SecondJobTab />
                </TabPanel>

                <TabPanel>
                  <ThirdJobTab />
                </TabPanel>

                <TabPanel>
                  <FifthJobTab />
                </TabPanel>

                <TabPanel>
                  <SixthJobTab />
                </TabPanel>
              </Tabs>
            </div>
          </div>
          {/* Mobile view */}
          {/* <div className="scrollable-tab-mobile ">
            <ScrollableTab />
          </div> */}
        </div>
      </section>
    </>
  );
};

export default JobTabs;